var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9102,
    cy: 19.108,
    r: 19,
    fill: "#ACCE42"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.775 24.442H11.089C10.669 24.442 10.375 24.106 10.375 23.728V14.488C10.375 14.068 10.711 13.774 11.089 13.774H24.067C24.487 13.774 24.781 14.11 24.781 14.488V23.686C24.781 24.106 24.445 24.4 24.067 24.4H22.807",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7812 17.218L28.4353 14.866C28.9393 14.572 29.5693 14.908 29.5693 15.496V22.216C29.5693 22.804 28.9393 23.14 28.4353 22.846L24.7812 20.494",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 0.107971H38.9102V38.108H0.910156V0.107971Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.41016,
    y: 8.60797,
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Video.4e89adad.svg";
export { ForwardRef as ReactComponent };